import { useQuery } from '@tanstack/react-query';
import { mockNotifications, Notification } from '@mocks/notifications';
import { queryKeys } from '../queryKeys';

// Mock API call
const fetchNotifications = async (): Promise<Notification[]> =>
  new Promise(resolve => {
    setTimeout(() => resolve(mockNotifications), 350);
  });

export const useNotifications = () =>
  useQuery({
    queryKey: queryKeys.notifications,
    queryFn: fetchNotifications,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
